// extracted by mini-css-extract-plugin
export var deliveryRow = "_q9-a";
export var fixedHeight = "_q9-4";
export var freightLogo = "_q9-9";
export var fullWidth = "_q9-3";
export var priceColumn = "_q9-5";
export var radioSelected = "_q9-7";
export var radioUnselected = "_q9-6";
export var selectedOption = "_q9-2";
export var selectedOptionContainer = "_q9-1";
export var selection = "_q9-0";
export var tallSkeletonText = "_q9-8";